import { BoostProvider, BoostTask } from '../../types/boost';
import { AdextraBoostProvider } from './AdextraBoostProvider';
import { OnClickABoostProvider } from './OnClickABoostProvider';
import { PROVIDERS } from '../../constants/providers';

export class RandomizedAdProvider implements BoostProvider {
    private currentProvider: BoostProvider | null = null;
    private currentType: 'adextra' | 'onclick' | null = null;

    private createProvider(): void {
        // Очищаем предыдущий провайдер
        this.resetProvider();

        // Выбираем случайно новый тип провайдера
        const isAdextra = Math.random() < 0.5;
        this.currentType = isAdextra ? 'adextra' : 'onclick';
        
        // Создаем только выбранный провайдер
        this.currentProvider = isAdextra 
            ? new AdextraBoostProvider() 
            : new OnClickABoostProvider();
            
        console.log(`RandomizedAdProvider: Инициализирован провайдер ${this.currentType}`);
    }

    private resetProvider(): void {
        if (this.currentProvider) {
            // Сбрасываем ошибки текущего провайдера перед его удалением
            this.resetError();
        }
        this.currentProvider = null;
        this.currentType = null;
        console.log('RandomizedAdProvider: Сброшено состояние провайдера');
    }

    getName(): string {
        if (!this.currentType) {
            this.createProvider();
        }
        return this.currentType === 'adextra' ? PROVIDERS.ADEXTRA : PROVIDERS.ONCLICK;
    }

    async getAvailableTasks(miningId: number): Promise<BoostTask[]> {
        // Всегда сбрасываем и создаем нового провайдера при запросе задач
        this.createProvider();
        
        if (!this.currentProvider) {
            return [];
        }

        try {
            const tasks = await this.currentProvider.getAvailableTasks(miningId);
            return tasks.map(task => ({
                ...task,
                provider: this.getName(),
                onClick: async () => {
                    try {
                        const result = await task.onClick();
                        // После выполнения задачи сбрасываем провайдер
                        this.resetProvider();
                        return result;
                    } catch (error) {
                        this.resetProvider();
                        throw error;
                    }
                }
            }));
        } catch (error) {
            this.resetProvider();
            return [];
        }
    }

    resetError(): void {
        if (this.currentProvider) {
            const provider = this.currentProvider as unknown as { resetError?: () => void };
            if (typeof provider.resetError === 'function') {
                provider.resetError();
            }
        }
    }
} 